(function() {
  function cleanStr(s) {
    return s.replace(/[^\x00-\x7F]/g, '').trim();
  }

  async function getProductData() {
    return fetch(location.pathname.split('?')[0] + '.js').then(r => r.json());
  }

  async function getBundleData(card) {
    const qtyVal = card.dataset.qtyValue;
    const cleanQtyVal = cleanStr(qtyVal);
    const selects = card.querySelectorAll('.spec-select');
    const productData = await getProductData();
    const firstSpecVal = selects[0]?.value || '';
    const bundleVariant = productData.variants.find(v => {
      return cleanStr(v.options[0]) === cleanStr(firstSpecVal) && cleanStr(v.options[1]) === cleanQtyVal;
    });
    if (!bundleVariant) return null;
    const properties = {};
    selects.forEach((sel, i) => { properties[`Item ${i + 1}`] = sel.value; });
    return { variantId: bundleVariant.id, properties };
  }

  async function clearBundleFromCart() {
    const productData = await getProductData();
    const productId = productData.id;
    const cart = await fetch('/cart.js').then(r => r.json());
    const updates = {};
    cart.items.forEach(item => {
      if (item.product_id === productId) {
        const itemQty = item.variant_options?.[1] || '';
        if (cleanStr(itemQty) !== 'Buy 1') updates[item.key] = 0;
      }
    });
    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    }
  }

  async function addBundleToCart(bundleData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: bundleData.variantId, quantity: 1, properties: bundleData.properties }]
      })
    });
    return res.ok;
  }

  async function openCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('#CartDrawer');
        const oldDrawer = document.querySelector('#CartDrawer');
        if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
      }
    } catch(e) { console.error(e); }
    const cd = document.querySelector('cart-drawer');
    const cartLink = document.querySelector('a.header__icon--cart');
    if (cd && typeof cd.open === 'function') cd.open(cartLink);
  }

  function syncFormVariant() {
    const card = document.querySelector('.bundle-card.selected');
    const paymentButtonContainer = document.querySelector('.shopify-payment-button');

    if (!card) return;
    const qty = parseInt(card.dataset.qty) || 1;

    if (qty <= 1) {
      if (paymentButtonContainer) paymentButtonContainer.style.display = '';
      return;
    }

    // Buy 2/3: 隐藏 Shop Pay 避免错误结账
    if (paymentButtonContainer) paymentButtonContainer.style.display = 'none';

    getBundleData(card).then(bundleData => {
      if (!bundleData) return;
      const idInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
      if (idInput) idInput.value = bundleData.variantId;
    });
  }

  function init() {
    // ===== ADD TO CART =====
    const addBtn = document.querySelector('button[name="add"]');
    if (addBtn && !addBtn.dataset.bundleHijacked) {
      addBtn.dataset.bundleHijacked = 'true';
      addBtn.addEventListener('click', async function(e) {
        const card = document.querySelector('.bundle-card.selected');
        if (!card) return;
        const qty = parseInt(card.dataset.qty) || 1;
        if (qty <= 1) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const originalHTML = addBtn.innerHTML;
        addBtn.innerHTML = 'Adding...';
        addBtn.disabled = true;

        try {
          const bundleData = await getBundleData(card);
          if (!bundleData) { addBtn.innerHTML = originalHTML; addBtn.disabled = false; return; }
          await clearBundleFromCart();
          const ok = await addBundleToCart(bundleData);
          addBtn.innerHTML = originalHTML;
          addBtn.disabled = false;
          if (ok) await openCartDrawer();
        } catch(err) {
          console.error(err);
          addBtn.innerHTML = originalHTML;
          addBtn.disabled = false;
        }
      }, true);
    }

    // ===== BUY IT NOW =====
    const buyNowBtn = document.querySelector('#SectionAtcBtn-template--22240995147994__main') ||
      Array.from(document.querySelectorAll('button')).find(btn =>
        btn.textContent.trim().toLowerCase() === 'buy it now'
      );
    if (buyNowBtn && !buyNowBtn.dataset.bundleHijacked) {
      buyNowBtn.dataset.bundleHijacked = 'true';
      buyNowBtn.addEventListener('click', async function(e) {
        const card = document.querySelector('.bundle-card.selected');
        if (!card) return;
        const qty = parseInt(card.dataset.qty) || 1;
        if (qty <= 1) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        try {
          const bundleData = await getBundleData(card);
          if (!bundleData) return;
          await clearBundleFromCart();
          await addBundleToCart(bundleData);
          window.location.href = '/checkout';
        } catch(err) { console.error(err); }
      }, true);
    }

    // ===== PAY WITH SHOP / 动态支付按钮 =====
    function hijackPaymentButtons() {
      document.querySelectorAll('.shopify-payment-button__more-options, .shopify-payment-button__button').forEach(btn => {
        if (btn.dataset.bundleHijacked) return;
        btn.dataset.bundleHijacked = 'true';
        btn.addEventListener('click', async function(e) {
          const card = document.querySelector('.bundle-card.selected');
          if (!card) return;
          const qty = parseInt(card.dataset.qty) || 1;
          if (qty <= 1) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          try {
            const bundleData = await getBundleData(card);
            if (!bundleData) return;
            await clearBundleFromCart();
            await addBundleToCart(bundleData);
            window.location.href = '/checkout';
          } catch(err) { console.error(err); }
        }, true);
      });
    }

    hijackPaymentButtons();

    // ===== 同步表单 variant + 隐藏Shop Pay =====
    document.addEventListener('click', function(e) {
      if (e.target.closest('.bundle-card') || e.target.closest('.spec-select')) {
        setTimeout(syncFormVariant, 100);
      }
    });
    setTimeout(syncFormVariant, 2000);

    const observer = new MutationObserver(() => hijackPaymentButtons());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1500);
})();

